import { render, staticRenderFns } from "./ProjectSwitch.vue?vue&type=template&id=cf7448c2&"
import script from "./ProjectSwitch.vue?vue&type=script&lang=js&"
export * from "./ProjectSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports